// app/javascript/projects/components/RootBody.jsx

import React, { useEffect, useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useProjects } from 'hooks/projects/queries';

const RootBody = () => {
  const location = useLocation();
  const history = useHistory();
  const { data: projectsData, isLoading } = useProjects();

  // Find the most recent project based on updated_at
  const newestProject = useMemo(() => {
    if (!projectsData?.projects || projectsData.projects.length === 0) {
      return null;
    }

    // Find the project with the most recent updated_at
    return projectsData.projects.reduce((newest, current) => {
      if (!newest || new Date(current.updated_at) >= new Date(newest.updated_at)) {
        return current;
      }
      return newest;
    }, null);
  }, [projectsData]);

  // Handle navigation based on project state
  useEffect(() => {
    if (isLoading) return;

    const isOnChatPage = location.pathname === '/chat';
    
    if (newestProject != null) {
      const targetPath = isOnChatPage 
        ? `/projects/${newestProject.id}/chat`
        : `/projects/${newestProject.id}`;
      history.push(targetPath);
    } else {
      history.push('/projects/new');
    }
  }, [isLoading, newestProject?.id, location.pathname, history]);

  return <div />;
};

export default RootBody;